/* =============================================================================
 * Interceptacao de cliques em links internos.
 *
 * Um unico listener no document, por delegacao - assim nenhuma view precisa
 * chamar pushState na mao, e links criados depois funcionam sem registro.
 * ========================================================================== */

import { navegar } from './roteador.js';

export function instalarLinks() {
    document.addEventListener('click', (ev) => {
        //Deixa passar: clique do meio, com modificador, ou ja' tratado.
        if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;

        const link = ev.target.closest('a[href]');
        if (!link) return;

        const href = link.getAttribute('href');
        //Externo, ancora, download, nova aba, ou marcado para escapar.
        if (!href?.startsWith('/') || href.startsWith('//')) return;
        if (link.target && link.target !== '_self') return;
        if (link.hasAttribute('download') || link.hasAttribute('data-externo')) return;

        ev.preventDefault();
        navegar(href);
    });
}
